import React, { useCallback, useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Button } from "../components";
import Content from "../components/addressbook/Content";
import AddressBookService from "../services/address_book";
import Registration from "../components/addressbook/Registration";
import { useNavigate } from "react-router-dom";
import { changeDocumentTitle } from "../lib";

const useStyles = makeStyles(() => ({
  contentContainer: {
    marginTop: 25,
    padding: 0,
    backgroundColor: "#ffffff",
    borderRadius: 3.8,
    border: "solid 1px #ebedf8",
  },
}));

export default function AddressBook() {
  const classes = useStyles();

  const [addressBook, setAddressBook] = useState<any[]>([]);
  const [refresh, setRefresh] = useState<boolean>(false);
  const [showRegistrationPage, setShowRegistrationPage] =
    useState<boolean>(false);

  const navigate = useNavigate();

  const refreshToggle = useCallback(() => {
    refresh ? setRefresh(false) : setRefresh(true);
  }, [refresh, setRefresh]);

  const refreshAddressBook = useCallback(async () => {
    try {
      const addressBookService = new AddressBookService(navigate);
      const response = await addressBookService.inquiry();
      setAddressBook(response.data.addressBook);
    } catch (e) {
      console.error("failed to handle addressBook:", e);
    }
  }, [setAddressBook]);

  const deleteAddress = useCallback(async (id: number) => {
    try {
      const addressBookService = new AddressBookService(navigate);
      await addressBookService.delete(id);
    } catch (e: any) {
      if (e.response !== undefined) {
        console.log(e.response.data);
        return;
      }
      console.error("failed to delete an address:", e.toString());
    }
  }, []);

  useEffect(() => {
    changeDocumentTitle("주소록");
    queueMicrotask(refreshAddressBook);
  }, []);

  return (
    <>
      {showRegistrationPage && (
        <Registration
          address={null}
          refresh={refreshAddressBook}
          close={() => setShowRegistrationPage(false)}
        />
      )}
      <Grid container direction={"column"}>
        <Grid item>
          <Button
            onClick={() => {
              setShowRegistrationPage(true);
            }}
            size={"large"}
          >
            주소 등록
          </Button>
        </Grid>
        <Grid item className={classes.contentContainer}>
          <Content
            deleteAddress={deleteAddress}
            refresh={refreshAddressBook}
            addressBook={addressBook}
          />
        </Grid>
      </Grid>
    </>
  );
}
